import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { useEffect, useRef, useState } from 'react';
import { getCompanyList, getEledgerLog, updateLucaCredentials, batchLucaReceipt, batchStatus, restartFailedSessions, getBatchs, updateSession, sendCertificate, ledgerView, reportData } from './requests/batchRequest';
import { getCompanyAndPeriodList, loginLuca, sendCaptcha } from '../module/luca/utils/lucaRequest';
import { deleteCompanyIsHere, getCompanyForDropdown } from '../module/luca/utils/util';
import { Toast } from 'primereact/toast';
import LucaUpdate from './LucaUpdate';
import Loading from '../Loading';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { Message } from 'primereact/message';
import { useLocation } from 'react-router-dom';
import { NotFound } from '../NotFound';

// Berat durum kodları (CertificateStatus)
const CertificateStatus = {
    WaitingForBuild: { kod: 0, intDegeri: 0, aciklama: 'Beklemede' },
    Building: { kod: 5, intDegeri: 1, aciklama: 'Hazırlanıyor' },
    UnsignedFileReady: { kod: 10, intDegeri: 2, aciklama: 'İmzasız dosya hazır' },
    FileSigned: { kod: 20, intDegeri: 3, aciklama: 'İmzalandı' },
    BeratGenerated: { kod: 30, intDegeri: 4, aciklama: 'Berat Oluşturuldu' },
    BeratSignedByCustomer: { kod: 40, intDegeri: 5, aciklama: 'Berat İmzalandı' },
    BeratSending: { kod: 45, intDegeri: 6, aciklama: 'Berat Gönderiliyor' },
    BeratSentToGIB: { kod: 50, intDegeri: 7, aciklama: "Berat GİB'e gönderildi" },
    Completed: { kod: 100, intDegeri: 8, aciklama: 'Tamamlandı' },
    Canceled: { kod: 200, intDegeri: 9, aciklama: 'İptal' },
    Error: { kod: 300, intDegeri: 10, aciklama: 'Hata' },
    Deleted: { kod: 400, intDegeri: 11, aciklama: 'Silindi' }
};

// Defter durum kodları (LedgerStatus)
const LedgerStatus = {
    WaitingForBuild: { kod: 0, intDegeri: 0, aciklama: 'Beklemede' },
    Building: { kod: 5, intDegeri: 1, aciklama: 'Hazırlanıyor' },
    UnsignedFileReady: { kod: 10, intDegeri: 2, aciklama: 'İmzasız dosya hazır' },
    FileSigned: { kod: 20, intDegeri: 3, aciklama: 'İmzalandı' },
    BeratGenerated: { kod: 30, intDegeri: 4, aciklama: 'Berat Oluşturuldu' },
    BeratSignedByCustomer: { kod: 40, intDegeri: 5, aciklama: 'Berat İmzalandı' },
    BeratSentToGIB: { kod: 50, intDegeri: 6, aciklama: "Berat GİB'e gönderildi" },
    Completed: { kod: 100, intDegeri: 7, aciklama: 'Tamamlandı' },
    Canceled: { kod: 200, intDegeri: 8, aciklama: 'İptal' },
    Error: { kod: 300, intDegeri: 9, aciklama: 'Hata' }
};

// Dosya Tipleri (LedgerFileTypes)
const LedgerFileTypes = {
    UnsignedLedgerFile: { intDegeri: 0, aciklama: 'İmzasız Defter' },
    SignedLedgerFile: { intDegeri: 1, aciklama: 'İmzalı Defter' },
    UnsignedCertificateFile: { intDegeri: 2, aciklama: 'İmzasız Berat' },
    SignedCertificateFile: { intDegeri: 3, aciklama: 'İmzalı Berat' },
    FinalCertificateFile: { intDegeri: 4, aciklama: 'Berat' }
};

// Defter Tipleri (LedgerType)
const LedgerType = {
    Journal: { intDegeri: 0, aciklama: 'Yevmiye Defteri' },
    Ledger: { intDegeri: 1, aciklama: 'Kebir Defteri' }
};

// Helper: Kod'a göre CertificateStatus bilgisi getir
const getCertificateStatusByCode = (kod) => {
    const kodNum = typeof kod === 'string' ? parseInt(kod, 10) : kod;
    for (const key in CertificateStatus) {
        if (CertificateStatus[key].kod === kodNum) {
            return { key, ...CertificateStatus[key] };
        }
    }
    return null;
};

// Helper: Kod'a göre LedgerStatus bilgisi getir
const getLedgerStatusByCode = (kod) => {
    const kodNum = typeof kod === 'string' ? parseInt(kod, 10) : kod;
    for (const key in LedgerStatus) {
        if (LedgerStatus[key].kod === kodNum) {
            return { key, ...LedgerStatus[key] };
        }
    }
    return null;
};

// Helper: Defter tipini al
const getLedgerTypeByValue = (value) => {
    const valueNum = typeof value === 'string' ? parseInt(value, 10) : value;
    for (const key in LedgerType) {
        if (LedgerType[key].intDegeri === valueNum) {
            return { key, ...LedgerType[key] };
        }
    }
    return null;
};

// Helper: Dosya tipini al
const getLedgerFileTypeByValue = (value) => {
    const valueNum = typeof value === 'string' ? parseInt(value, 10) : value;
    for (const key in LedgerFileTypes) {
        if (LedgerFileTypes[key].intDegeri === valueNum) {
            return { key, ...LedgerFileTypes[key] };
        }
    }
    return null;
};

// Helper: Status koduna göre UI bilgisi getir (renk, ikon vs.)
const getStatusUIInfo = (statusCode, statusString = null) => {
    const kodNum = typeof statusCode === 'string' ? parseInt(statusCode, 10) : statusCode;

    // Önce string status'a bak
    if (statusString) {
        const lowerStatus = statusString.toLowerCase();
        switch (lowerStatus) {
            case 'processing':
                return { text: 'İşleniyor', severity: 'warning', icon: 'pi pi-spin pi-spinner', color: 'bg-yellow-500' };
            case 'completed':
                return { text: 'Tamamlandı', severity: 'success', icon: 'pi pi-check', color: 'bg-green-500' };
            case 'failed':
                return { text: 'Başarısız', severity: 'danger', icon: 'pi pi-times', color: 'bg-red-500' };
            case 'canceled':
                return { text: 'İptal', severity: 'warning', icon: 'pi pi-times-circle', color: 'bg-orange-500' };
            case 'error':
                return { text: 'Hata', severity: 'danger', icon: 'pi pi-exclamation-triangle', color: 'bg-red-500' };
            case 'pending':
                return { text: 'Beklemede', severity: 'info', icon: 'pi pi-clock', color: 'bg-blue-500' };
            case 'waiting':
                return { text: 'Kuyrukta', severity: 'info', icon: 'pi pi-clock', color: 'bg-blue-400' };
            default:
                break;
        }
    }

    // Status koduna göre UI bilgisi
    switch (kodNum) {
        case CertificateStatus.WaitingForBuild.kod: // 0
            return { text: CertificateStatus.WaitingForBuild.aciklama, severity: 'info', icon: 'pi pi-clock', color: 'bg-blue-500' };
        case CertificateStatus.Building.kod: // 5
            return { text: CertificateStatus.Building.aciklama, severity: 'warning', icon: 'pi pi-spin pi-spinner', color: 'bg-yellow-500' };
        case CertificateStatus.UnsignedFileReady.kod: // 10
            return { text: CertificateStatus.UnsignedFileReady.aciklama, severity: 'info', icon: 'pi pi-file', color: 'bg-cyan-500' };
        case CertificateStatus.FileSigned.kod: // 20
            return { text: CertificateStatus.FileSigned.aciklama, severity: 'info', icon: 'pi pi-check-circle', color: 'bg-teal-500' };
        case CertificateStatus.BeratGenerated.kod: // 30
            return { text: CertificateStatus.BeratGenerated.aciklama, severity: 'info', icon: 'pi pi-file-edit', color: 'bg-indigo-500' };
        case CertificateStatus.BeratSignedByCustomer.kod: // 40
            return { text: CertificateStatus.BeratSignedByCustomer.aciklama, severity: 'help', icon: 'pi pi-check-circle', color: 'bg-purple-500' };
        case CertificateStatus.BeratSending.kod: // 45
            return { text: CertificateStatus.BeratSending.aciklama, severity: 'warning', icon: 'pi pi-spin pi-spinner', color: 'bg-orange-400' };
        case CertificateStatus.BeratSentToGIB.kod: // 50
            return { text: CertificateStatus.BeratSentToGIB.aciklama, severity: 'info', icon: 'pi pi-send', color: 'bg-blue-600' };
        case CertificateStatus.Completed.kod: // 100
            return { text: CertificateStatus.Completed.aciklama, severity: 'success', icon: 'pi pi-check', color: 'bg-green-500' };
        case CertificateStatus.Canceled.kod: // 200
            return { text: CertificateStatus.Canceled.aciklama, severity: 'warning', icon: 'pi pi-times-circle', color: 'bg-orange-500' };
        case CertificateStatus.Error.kod: // 300
            return { text: CertificateStatus.Error.aciklama, severity: 'danger', icon: 'pi pi-exclamation-triangle', color: 'bg-red-500' };
        case CertificateStatus.Deleted.kod: // 400
            return { text: CertificateStatus.Deleted.aciklama, severity: 'danger', icon: 'pi pi-trash', color: 'bg-gray-500' };
        default:
            return { text: statusString || 'Bilinmeyen', severity: 'secondary', icon: 'pi pi-question', color: 'bg-gray-400' };
    }
};

// Add locale data for Turkish calendar
const localeDate = {
    firstDayOfWeek: 1,
    dayNames: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
    dayNamesShort: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'],
    dayNamesMin: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
    monthNames: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
    monthNamesShort: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
    today: 'Bugün',
    clear: 'Temizle'
};

const decodeBatchId = (path) => {
    const pathParts = path.split('/');
    const batchLucaPageIndex = pathParts.findIndex((part) => part === 'batchLucaPage');
    let decodedId = null;

    if (batchLucaPageIndex !== -1 && pathParts[batchLucaPageIndex + 1]) {
        const idPart = pathParts.slice(batchLucaPageIndex + 1).join('/');
        decodedId = decodeURIComponent(idPart);
    }
    return decodedId;
};

export default function LucaBatch() {
    const dt = useRef(null);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [selectedReceipt, setSelectedReceipt] = useState([]);
    const [visible, setVisible] = useState(false);
    const [updateTabVisible, setUpdateTabVisible] = useState(false);
    const [updateCompanyData, setUpdateCompanyData] = useState(null);
    const [companyList, setCompanyList] = useState(null);
    const [lucaUsername, setLucaUsername] = useState(null);
    const [lucaPassword, setLucaPassword] = useState(null);
    const [lucaCustomerNumber, setLucaCustomerNumber] = useState(null);
    const [loading, setLoading] = useState(true);
    const [cookies, setCookies] = useState(null);
    const [captcha, setCaptcha] = useState(null);
    const [captchaImage, setCaptchaImage] = useState(null);
    const [captchaVisible, setCaptchaVisible] = useState(false);
    const [jSessionId, setJSessionId] = useState(null);
    const [wMonId, setWMonId] = useState(null);
    const [response, setResponse] = useState(null);
    const [isLoginLuca, setIsLoginLuca] = useState(false);
    const [updateCredentialsVisible, setUpdateCredentialsVisible] = useState(false);
    const [enteredBy, setEnteredBy] = useState(null);
    const [captchaLoading, setCaptchaLoading] = useState(false);
    const [lucaCompanies, setLucaCompanies] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedMonthNumber, setSelectedMonthNumber] = useState(null);
    const [loadingForSend, setLoadingForSend] = useState(false);
    const [eledgerLog, setEledgerLog] = useState([]);
    const [batchIntervalId, setBatchIntervalId] = useState(null);
    const [eledgerLogIntervalId, setEledgerLogIntervalId] = useState(null);
    const [batchListIntervalId, setBatchListIntervalId] = useState(null);
    const [currentBatchId, setCurrentBatchId] = useState(null);
    const [batchStatusData, setBatchStatusData] = useState([]);
    const [batchListData, setBatchListData] = useState([]);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [expandedRows, setExpandedRows] = useState(null);
    const [retrySessionVisible, setRetrySessionVisible] = useState(false);
    const [retrySessionData, setRetrySessionData] = useState(null);
    const [retryYear, setRetryYear] = useState(null);
    const [retryMonth, setRetryMonth] = useState(null);
    const [retrySelectedMonth, setRetrySelectedMonth] = useState(null);
    const [retryEnteredBy, setRetryEnteredBy] = useState(null);
    const [loadingForRetry, setLoadingForRetry] = useState(false);
    const toast = useRef(null);
    const batchIntervalRef = useRef(null);
    const eledgerLogIntervalRef = useRef(null);
    const batchListIntervalRef = useRef(null);
    const location = useLocation();
    const [confirmationVisible, setConfirmationVisible] = useState(false);
    const [noCompany, setNoCompany] = useState(false);
    const [certificateConfirmVisible, setCertificateConfirmVisible] = useState(false);
    const [selectedLedgerForCertificate, setSelectedLedgerForCertificate] = useState(null);
    const [loadingCertificate, setLoadingCertificate] = useState(false);
    const certificatePollingIntervalRef = useRef(null);
    const [batchCertificateConfirmVisible, setBatchCertificateConfirmVisible] = useState(false);
    const [selectedLedgersForBatchCertificate, setSelectedLedgersForBatchCertificate] = useState([]);
    const [completedFilter, setCompletedFilter] = useState(false);
    const [lucaConnectionFilter, setLucaConnectionFilter] = useState(false);
    const [notSentFilter, setNotSentFilter] = useState(false);
    const [expansionNotSentFilter, setExpansionNotSentFilter] = useState({});
    const [downloadingLedgerId, setDownloadingLedgerId] = useState(null);
    const [downloadingCertificateId, setDownloadingCertificateId] = useState(null);
    const [downloadingReportId, setDownloadingReportId] = useState(null);
    const [pdfViewerVisible, setPdfViewerVisible] = useState(false);
    const [pdfViewerData, setPdfViewerData] = useState(null);
    const [pdfViewerLoading, setPdfViewerLoading] = useState(false);
    const [certificatePdfViewerLoading, setCertificatePdfViewerLoading] = useState(false);

    const [batchParams, setBatchParams] = useState(decodeBatchId(location.pathname));
    const batchParamsRef = useRef(decodeBatchId(location.pathname));

    addLocale('tr', localeDate);

    // Responsive scroll height function
    const getScrollHeight = () => {
        if (windowWidth < 768) {
            return '300px'; // Mobile
        } else if (windowWidth < 1024) {
            return '400px'; // Tablet
        } else if (windowWidth < 1440) {
            return '500px'; // Small desktop
        } else {
            return '600px'; // Large desktop
        }
    };

    useEffect(() => {
        const newBatchParams = decodeBatchId(location.pathname);
        setBatchParams(newBatchParams);
        batchParamsRef.current = newBatchParams; // Ref'i güncelle

        getCompanyListFunc();
        getEledgerLogFunc();
        getBatchListFunc();
        startEledgerLogPolling();
        startBatchListPolling();
    }, [location.pathname]);

    useEffect(() => {
        // İlk yüklenme için de ref'i güncelle
        batchParamsRef.current = decodeBatchId(location.pathname);
        getCompanyListFunc();
        getEledgerLogFunc();
        getBatchListFunc();
        startEledgerLogPolling();
        startBatchListPolling();

        // Component unmount olduğunda session bilgilerini temizle
        return () => {
            setJSessionId(null);
            setWMonId(null);
        };
    }, []);

    // Window resize listener
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Cleanup interval on component unmount
    useEffect(() => {
        return () => {
            if (batchIntervalRef.current) {
                clearInterval(batchIntervalRef.current);
                batchIntervalRef.current = null;
            }
            if (eledgerLogIntervalRef.current) {
                clearInterval(eledgerLogIntervalRef.current);
                eledgerLogIntervalRef.current = null;
            }
            if (batchListIntervalRef.current) {
                clearInterval(batchListIntervalRef.current);
                batchListIntervalRef.current = null;
            }
            if (certificatePollingIntervalRef.current) {
                clearInterval(certificatePollingIntervalRef.current);
                certificatePollingIntervalRef.current = null;
            }
        };
    }, []);

    const getCompanyListFunc = async () => {
        setLoading(true);
        try {
            const response = await getCompanyList(batchParamsRef.current);

            if (response.data.data.length === 0) {
                setNoCompany(true);
                return;
            }
            setNoCompany(false);

            setCompanyList(response.data.data);

            const foundCompany = response.data.data.find((company) => {
                return company.username && company.password && company.customer_number;
            });

            if (foundCompany) {
                setLucaUsername(foundCompany.username);
                setLucaPassword(foundCompany.password);
                setLucaCustomerNumber(foundCompany.customer_number);
            }
        } catch (error) {
            setUpdateCredentialsVisible(true);
        } finally {
            setLoading(false);
        }
    };

    const settingLoadingState = (state) => {
        setLoading(state);
    };

    const getEledgerLogFunc = async () => {
        try {
            const res = await getEledgerLog(batchParamsRef.current);
            setEledgerLog(res.data.data);
        } catch (error) {
            setTimeout(() => {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: error?.response?.data?.message, life: 3000 });
            }, 1);
        } finally {
        }
    };

    const getBatchListFunc = async () => {
        try {
            const res = await getBatchs(batchParamsRef.current);
            setBatchListData(res.data.data);

            // Aktif batch'leri kontrol et ve polling başlat
            const activeBatches = res.data.data.filter((batch) => batch.status === 'processing' || batch.status === 'pending' || batch.status === 'login' || batch.status === 'success' || batch.status === 'error');

            if (activeBatches.length > 0) {
                const latestActiveBatch = activeBatches.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];

                if (latestActiveBatch && latestActiveBatch.batch_id) {
                    // Eğer farklı bir batch aktifse, eski polling'i durdur ve yenisini başlat
                    if (currentBatchId && currentBatchId !== latestActiveBatch.batch_id) {
                        stopBatchPolling();
                        startBatchPolling(latestActiveBatch.batch_id);
                    }
                    // Eğer hiç polling yoksa başlat
                    else if (!currentBatchId) {
                        startBatchPolling(latestActiveBatch.batch_id);
                    }
                    // Eğer aynı batch zaten çalışıyorsa devam etsin
                }
            } else {
                // Aktif batch yoksa polling'i durdur
                if (currentBatchId) {
                    stopBatchPolling();
                }
            }
        } catch (error) {
            setTimeout(() => {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: error?.response?.data?.message, life: 3000 });
            }, 1);
        }
    };

    const checkBatchStatus = async (batchId) => {
        try {
            const res = await batchStatus(batchId, batchParamsRef.current);

            if (!res.data || !res.data.success || !res.data.data) {
                stopBatchPolling();
                setBatchStatusData([]);
                setTimeout(() => {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Geçersiz işlem durum yanıtı', life: 3000 });
                }, 1);
                return;
            }

            if (res.data.data.total_sessions === 0) {
                stopBatchPolling();
                setBatchStatusData([]);
                setTimeout(() => {
                    toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Toplu işlem tamamlandı', life: 3000 });
                }, 1);
                getEledgerLogFunc();
                return;
            }

            // sessions array'i varsa ve içinde veri varsa state'e kaydet
            if (res.data.data.sessions && Array.isArray(res.data.data.sessions)) {
                setBatchStatusData(res.data.data.sessions);
            } else {
                setBatchStatusData([]);
            }

            getEledgerLogFunc();
        } catch (error) {
            stopBatchPolling();
            setBatchStatusData([]);
            setTimeout(() => {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Toplu işlem durum kontrolünde hata oluştu', life: 3000 });
            }, 1);
        }
    };

    const startBatchPolling = (batchId) => {
        if (batchIntervalRef.current) {
            clearInterval(batchIntervalRef.current);
            batchIntervalRef.current = null;
        }

        setCurrentBatchId(batchId);

        const intervalId = setInterval(() => {
            checkBatchStatus(batchId);
        }, 10000);

        batchIntervalRef.current = intervalId;
        setBatchIntervalId(intervalId); // UI için state'i de güncelle

        checkBatchStatus(batchId);
    };

    const stopBatchPolling = () => {
        if (batchIntervalRef.current) {
            clearInterval(batchIntervalRef.current);
            batchIntervalRef.current = null;
            setBatchIntervalId(null);
        }
        setCurrentBatchId(null);
        setBatchStatusData([]);
    };

    const startEledgerLogPolling = () => {
        if (eledgerLogIntervalRef.current) {
            clearInterval(eledgerLogIntervalRef.current);
            eledgerLogIntervalRef.current = null;
        }

        const intervalId = setInterval(() => {
            getEledgerLogFunc();
        }, 10000);

        eledgerLogIntervalRef.current = intervalId;
        setEledgerLogIntervalId(intervalId);
    };

    const stopEledgerLogPolling = () => {
        if (eledgerLogIntervalRef.current) {
            clearInterval(eledgerLogIntervalRef.current);
            eledgerLogIntervalRef.current = null;
            setEledgerLogIntervalId(null);
        }
    };

    const startBatchListPolling = () => {
        if (batchListIntervalRef.current) {
            clearInterval(batchListIntervalRef.current);
            batchListIntervalRef.current = null;
        }

        const intervalId = setInterval(() => {
            getBatchListFunc();
        }, 10000);

        batchListIntervalRef.current = intervalId;
        setBatchListIntervalId(intervalId);
    };

    const stopBatchListPolling = () => {
        if (batchListIntervalRef.current) {
            clearInterval(batchListIntervalRef.current);
            batchListIntervalRef.current = null;
            setBatchListIntervalId(null);
        }
    };

    const handleSelectedReceiptCheck = () => {
        return !selectedReceipt?.length === 0 || selectedReceipt?.some((receipt) => !receipt.luca_company_id);
    };

    const hasFailedSessions = () => {
        // getBatchs API'sinden gelen error batch'ler
        const errorBatchesFromList = batchListData.some((batch) => batch?.status?.toLowerCase() === 'error');

        // batchStatus API'sinden gelen error session'lar
        const errorSessionsFromStatus = batchStatusData.some((session) => session?.status?.toLowerCase() === 'error');

        const errorELedgerLogs = eledgerLog.some((log) => log?.status?.toLowerCase() === 'error');

        return errorBatchesFromList || errorSessionsFromStatus || errorELedgerLogs;
    };

    const hasErrorSessionForCompany = (taxNumber) => {
        return batchStatusData.some((session) => session.company.tax_number === taxNumber && session?.status?.toLowerCase() === 'error');
    };

    const getErrorSessionForCompany = (taxNumber) => {
        return batchStatusData.find((session) => session.company.tax_number === taxNumber && session?.status?.toLowerCase() === 'error');
    };

    const hasSignedLedgerForCompany = (taxNumber) => {
        const logItems = eledgerLog.filter((item) => item.tax_number === taxNumber);

        return logItems.some((item) => {
            return (
                item.ledgers &&
                item.ledgers.length > 0 &&
                item.ledgers.some((ledger) => {
                    const code = typeof ledger.statusCode === 'string' ? parseInt(ledger.statusCode, 10) : ledger.statusCode;
                    return code === 40;
                })
            );
        });
    };

    // Tek bir imzalı defter döndürür (tekli gönderim için)
    const getSignedLedgerForCompany = (taxNumber) => {
        const logItems = eledgerLog.filter((item) => item.tax_number === taxNumber);
        for (const item of logItems) {
            if (item.ledgers) {
                const signedLedger = item.ledgers.find((ledger) => {
                    const code = typeof ledger.statusCode === 'string' ? parseInt(ledger.statusCode, 10) : ledger.statusCode;
                    return code === 40;
                });
                if (signedLedger) {
                    return { ...signedLedger, period: item.period, month: item.month, ...item };
                }
            }
        }
        return null;
    };

    // Tüm imzalı defterleri döndürür (toplu gönderim için)
    const getAllSignedLedgersForCompany = (taxNumber) => {
        const logItems = eledgerLog.filter((item) => item.tax_number === taxNumber);
        const signedLedgers = [];

        for (const item of logItems) {
            if (item.ledgers) {
                item.ledgers.forEach((ledger) => {
                    const code = typeof ledger.statusCode === 'string' ? parseInt(ledger.statusCode, 10) : ledger.statusCode;
                    if (code === 40) {
                        signedLedgers.push({
                            ...ledger,
                            ledger_uuid: item.ledger_uuid, // Bu önemli! API'ye gönderilecek
                            period: item.period,
                            month: item.month,
                            tax_number: item.tax_number,
                            total_debit: item.total_debit,
                            total_credit: item.total_credit,
                            row_count: item.row_count
                        });
                    }
                });
            }
        }
        return signedLedgers;
    };

    const handleOpenRetryDialog = (rowData) => {
        const errorSession = getErrorSessionForCompany(rowData.tax_number);
        if (errorSession) {
            setRetrySessionData(errorSession);
            setRetryYear(errorSession.period.year);
            setRetryMonth(errorSession.period.month);

            // Calendar için Date objesi oluştur
            const year = parseInt(errorSession.period.year);
            const month = parseInt(errorSession.period.month) - 1; // Calendar ay değeri 0-indexli
            const dateObject = new Date(year, month, 1);
            setRetrySelectedMonth(dateObject);

            setRetryEnteredBy(errorSession.entered_by || null);
            setRetrySessionVisible(true);
        }
    };

    const hasAnySignedLedgers = () => {
        if (!selectedReceipt || selectedReceipt.length === 0) return false;
        // Seçili şirketlerin HEPSİNDE imzalı defter varsa true döner (sadece berat imzalandı durumundakiler gönderilebilir)
        return selectedReceipt.every((company) => hasSignedLedgerForCompany(company.tax_number));
    };

    const hasOnlyUnsignedCompanies = () => {
        if (!selectedReceipt || selectedReceipt.length === 0) return false;
        // Seçili şirketlerin hiçbirinde imzalı defter yoksa true döner
        return selectedReceipt.every((company) => !hasSignedLedgerForCompany(company.tax_number));
    };

    const handleBatchCertificateSend = () => {
        // Seçili şirketlerde TÜM imzalanmış defterleri bul (statusCode === '40')
        // Aynı ledger_uuid'ye sahip defterleri grupla (Yevmiye ve Kebir aynı uuid'ye sahip)
        const ledgersByUuid = new Map();

        selectedReceipt.forEach((company) => {
            // O şirkete ait tüm imzalı defterleri al
            const allSignedLedgers = getAllSignedLedgersForCompany(company.tax_number);

            allSignedLedgers.forEach((ledger) => {
                const uuid = ledger.ledger_uuid;

                if (!ledgersByUuid.has(uuid)) {
                    // İlk kez bu uuid'yi görüyoruz, yeni kayıt oluştur
                    ledgersByUuid.set(uuid, {
                        ledger_uuid: uuid,
                        company_name: company.luca_company_name,
                        tax_number: company.tax_number,
                        period: ledger.period,
                        month: ledger.month,
                        total_debit: ledger.total_debit,
                        total_credit: ledger.total_credit,
                        row_count: ledger.row_count,
                        ledgerTypes: [ledger.type] // Yevmiye veya Kebir
                    });
                } else {
                    // Bu uuid zaten var, defter tipini ekle
                    const existing = ledgersByUuid.get(uuid);
                    if (!existing.ledgerTypes.includes(ledger.type)) {
                        existing.ledgerTypes.push(ledger.type);
                    }
                }
            });
        });

        // Map'i array'e çevir
        const ledgersToSend = Array.from(ledgersByUuid.values());

        if (ledgersToSend.length === 0) {
            setTimeout(() => {
                toast.current.show({
                    severity: 'warn',
                    summary: 'Uyarı',
                    detail: 'Seçili şirketlerde gönderilebilecek imzalanmış defter bulunamadı',
                    life: 3000
                });
            }, 1);
            return;
        }

        setSelectedLedgersForBatchCertificate(ledgersToSend);
        setBatchCertificateConfirmVisible(true);
    };

    const handleConfirmBatchCertificateSend = async () => {
        if (!selectedLedgersForBatchCertificate || selectedLedgersForBatchCertificate.length === 0) {
            return;
        }

        setBatchCertificateConfirmVisible(false);
        setLoadingCertificate(true);

        let successCount = 0;
        let errorCount = 0;
        const errors = [];

        try {
            // Her bir defter için sırayla gönder
            for (const ledger of selectedLedgersForBatchCertificate) {
                try {
                    await sendCertificate({ ledger_uuid: ledger.ledger_uuid }, batchParamsRef.current);
                    successCount++;
                } catch (error) {
                    errorCount++;
                    errors.push({
                        company: ledger.company_name || ledger.tax_number,
                        error: error?.response?.data?.message || 'Bilinmeyen hata'
                    });
                }
            }

            // Sonuçları göster
            if (errorCount === 0) {
                setTimeout(() => {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Başarılı',
                        detail: `${successCount} adet e-Defter başarıyla gönderildi. Kontrol edilmeye başlandı.`,
                        life: 5000
                    });
                }, 1);
            } else if (successCount === 0) {
                setTimeout(() => {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Hata',
                        detail: `Tüm gönderimler başarısız oldu (${errorCount} adet)`,
                        life: 5000
                    });
                }, 1);
            } else {
                setTimeout(() => {
                    toast.current.show({
                        severity: 'warn',
                        summary: 'Kısmi Başarı',
                        detail: `${successCount} başarılı, ${errorCount} başarısız gönderim`,
                        life: 5000
                    });
                }, 1);
            }

            // E-defter loglarını yenile
            getEledgerLogFunc();

            // 30 dakikalık polling'i başlat
            if (successCount > 0) {
                startCertificatePolling();
            }

            // Seçimleri temizle
            setSelectedLedgersForBatchCertificate([]);
        } finally {
            setLoadingCertificate(false);
        }
    };

    const getFilteredCompanyList = () => {
        if (!companyList) return [];

        let filtered = [...companyList];

        // Completed filtresi
        if (completedFilter) {
            filtered = filtered.filter((company) => {
                const logs = eledgerLog.filter((log) => log.tax_number === company.tax_number);
                const batches = batchListData.filter((batch) => batch.tax_number === company.tax_number);

                // Batch varsa, batch durumunu kontrol et
                if (batches.length > 0) {
                    return batches.some((batch) => batch.batchs && batch.batchs.some((b) => b.status === 'completed'));
                }

                // Log varsa, log durumunu kontrol et
                if (logs.length > 0) {
                    return logs.some((log) => {
                        if (log.ledgers && log.ledgers.length > 0) {
                            return log.ledgers.some((ledger) => ledger.status === 'completed' || ledger.statusCode === '100');
                        }
                        return log.status === 'completed';
                    });
                }

                return false;
            });
        }

        // Luca bağlantısı filtresi
        if (lucaConnectionFilter) {
            filtered = filtered.filter((company) => company.luca_company_id !== null);
        }

        // Gönderilmeyenler filtresi
        if (notSentFilter) {
            filtered = filtered.filter((company) => {
                const logs = eledgerLog.filter((log) => log.tax_number === company.tax_number);
                const batches = batchListData.filter((batch) => batch.tax_number === company.tax_number);

                // Hiç log veya batch yoksa gönderilmemiştir
                if (logs.length === 0 && batches.length === 0) {
                    return true;
                }

                // Batch varsa durumu kontrol et
                if (batches.length > 0) {
                    const hasCompleted = batches.some((batch) => batch.batchs && batch.batchs.some((b) => b.status === 'completed'));
                    if (hasCompleted) return false;
                }

                // Log varsa durumu kontrol et
                if (logs.length > 0) {
                    const hasCompleted = logs.some((log) => {
                        if (log.ledgers && log.ledgers.length > 0) {
                            return log.ledgers.some((ledger) => ledger.status === 'completed' || ledger.statusCode === '100');
                        }
                        return log.status === 'completed';
                    });
                    if (hasCompleted) return false;
                }

                return true;
            });
        }

        return filtered;
    };

    const handleRestartFailedSessions = async () => {
        // getBatchs'den gelen error batch'ler
        const errorBatchesFromList = batchListData.filter((batch) => batch?.status?.toLowerCase() === 'error');

        // batchStatus'dan gelen error session'lar varsa currentBatchId'yi restart et
        const hasErrorSessions = batchStatusData.some((session) => session?.status?.toLowerCase() === 'error');

        const hasErrorELedgerLogs = eledgerLog.some((log) => log?.status?.toLowerCase() === 'error');

        const batchesToRestart = [];

        // getBatchs'den error batch'leri ekle
        errorBatchesFromList.forEach((batch) => {
            if (!batchesToRestart.find((b) => b.batch_id === batch.batch_id)) {
                batchesToRestart.push(batch);
            }
        });

        // Eğer eLedger'da error log'lar varsa onları da ekle
        if (hasErrorELedgerLogs) {
            eledgerLog.forEach((log) => {
                if (!batchesToRestart.find((b) => b.batch_id === log.uuid)) {
                    batchesToRestart.push({ batch_id: log.uuid });
                }
            });
        }

        // Eğer aktif batch'te error session'lar varsa onu da ekle
        if (hasErrorSessions && currentBatchId) {
            const currentBatch = { batch_id: currentBatchId };
            if (!batchesToRestart.find((b) => b.batch_id === currentBatchId)) {
                batchesToRestart.push(currentBatch);
            }
        }

        if (batchesToRestart.length === 0) {
            setTimeout(() => {
                toast.current.show({ severity: 'warn', summary: 'Uyarı', detail: 'Başarısız toplu işlem bulunamadı', life: 3000 });
            }, 1);
            return;
        }

        try {
            setLoading(true);

            // Her error batch için restart işlemi
            for (const batch of batchesToRestart) {
                await restartFailedSessions({ uuid: batch.batch_id }, batchParamsRef.current);
            }

            setTimeout(() => {
                toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Başarısız toplu işlemler yeniden başlatıldı', life: 3000 });
            }, 1);

            // Restart işlemi başarılı olunca eski error session'ları temizle
            setBatchStatusData([]);

            // Eğer restart edilen batch'lerden biri currentBatchId ise polling'i yeniden başlat
            const restartedCurrentBatch = batchesToRestart.find((b) => b.batch_id === currentBatchId);
            if (restartedCurrentBatch) {
                stopBatchPolling();
                // Kısa bir süre bekle ve polling'i yeniden başlat
                setTimeout(() => {
                    startBatchPolling(currentBatchId);
                }, 2000);
            }

            // Batch listesini yenile
            getBatchListFunc();
        } catch (error) {
            setTimeout(() => {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: error?.response?.data?.message, life: 3000 });
            }, 1);
        } finally {
            setLoading(false);
        }
    };

    const header = (
        <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
            <div className="flex align-items-center gap-5">
                <h4 className="m-0">Luca Şirket Listesi</h4>
                {currentBatchId && !hasFailedSessions() && (
                    <div className="ml-3 flex align-items-center">
                        <Message text="Toplu İşlem Devam Ediyor" severity="info" className="mr-2"></Message>
                    </div>
                )}
                <div className="flex gap-2">
                    {completedFilter || lucaConnectionFilter || notSentFilter ? (
                        <Button
                            label="Filtreleri Temizle"
                            icon="pi pi-times"
                            className="p-button-secondary"
                            onClick={() => {
                                setCompletedFilter(false);
                                setLucaConnectionFilter(false);
                                setNotSentFilter(false);
                            }}
                        />
                    ) : (
                        <>
                            <Button label="Tamamlananları Göster" icon="pi pi-check" className="p-button-success text-white" onClick={() => setCompletedFilter(true)} />
                            <Button label="Luca Bağlantısı Olanları Göster" icon="pi pi-link" className="p-button-info text-white" onClick={() => setLucaConnectionFilter(true)} />
                            <Button label="Gönderilmeyenleri Göster" icon="pi pi-ban" className="p-button-danger text-white" onClick={() => setNotSentFilter(true)} />
                        </>
                    )}
                </div>
                {handleSelectedReceiptCheck() && <Message text="Seçili şirketlerde eksik bilgiler var lütfen güncelleyiniz." severity="error"></Message>}
            </div>

            <div className="flex gap-2 align-items-center">
                {hasFailedSessions() && <Button label="Başarısızları Tekrar Dene" icon="pi pi-clock" className="p-button-danger text-white mr-2" onClick={handleRestartFailedSessions} disabled={loading} />}
                {hasAnySignedLedgers() && (
                    <Button label="Seçili Şirketlerin Defterlerini Gönder" icon="pi pi-send" className="p-button-info text-white mr-2" onClick={handleBatchCertificateSend} disabled={loading || loadingCertificate} loading={loadingCertificate} />
                )}
                <Button label="Luca Bilgilerini Güncelleme" icon="pi pi-refresh" className="mr-2" onClick={() => setUpdateCredentialsVisible(true)} />
                {hasOnlyUnsignedCompanies() && (
                    <div className="flex align-items-center gap-2">
                        <Button
                            label={selectedReceipt?.length > 1 ? 'Toplu Gönder' : 'Gönder'}
                            icon="pi pi-send"
                            className="p-button-success text-white"
                            onClick={() => handleSend()}
                            disabled={handleSelectedReceiptCheck() || currentBatchId !== null || selectedReceipt?.length === 0 || !selectedMonth || !selectedYear || !enteredBy}
                            loading={loadingForSend}
                        />
                    </div>
                )}
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Ara..." />
                </span>
            </div>
        </div>
    );

    const actionBodyTemplate = (rowData) => {
        const handleExpandRow = (e) => {
            e.stopPropagation();
            const newExpandedRows = { ...expandedRows };
            if (newExpandedRows[rowData.id]) {
                delete newExpandedRows[rowData.id];
            } else {
                newExpandedRows[rowData.id] = true;
            }
            setExpandedRows(newExpandedRows);
        };

        const hasErrorSession = hasErrorSessionForCompany(rowData.tax_number);
        const hasSignedLedger = hasSignedLedgerForCompany(rowData.tax_number);
        /* const canSignByAccountant = rowData.can_sign_by_accountant === '1'; */
        const canSignByAccountant = true;

        return (
            <div className="align-items-center justify-content-center flex gap-2">
                {allowExpansion(rowData) && <Button severity="help" icon="pi pi-eye" className="p-button-sm" rounded tooltip="Detayları görüntüle" tooltipOptions={{ position: 'top' }} onClick={handleExpandRow} />}

                {hasSignedLedger && (
                    <Button
                        severity="success"
                        tooltip={canSignByAccountant ? 'Gönder' : 'Bu işlemi yapmak için portaldan yetkiniz olmalıdır.'}
                        size="small"
                        tooltipOptions={{ position: 'top', mouseTrack: true, mouseTrackTop: 15 }}
                        rounded
                        disabled={!canSignByAccountant}
                        className="text-white"
                        icon="pi pi-send"
                        onClick={() => {
                            const signedLedger = getSignedLedgerForCompany(rowData.tax_number);
                            if (signedLedger) {
                                setSelectedLedgerForCertificate({
                                    ledger_uuid: signedLedger.ledger_uuid,
                                    company_name: rowData.luca_company_name,
                                    tax_number: rowData.tax_number,
                                    period: signedLedger.period,
                                    month: signedLedger.month,
                                    ledger_type: signedLedger.ledgerType
                                });
                                setCertificateConfirmVisible(true);
                            }
                        }}
                    />
                )}

                {hasErrorSession && (
                    <Button
                        severity="danger"
                        tooltip="İşlemi Tekrar Dene"
                        size="small"
                        tooltipOptions={{ position: 'top', mouseTrack: true, mouseTrackTop: 15 }}
                        rounded
                        loading={loading}
                        className="text-white"
                        icon="pi pi-refresh"
                        onClick={() => handleOpenRetryDialog(rowData)}
                    />
                )}

                <Button
                    severity="primary"
                    tooltip="Güncelle"
                    size="small"
                    tooltipOptions={{ position: 'top', mouseTrack: true, mouseTrackTop: 15 }}
                    rounded
                    loading={loading}
                    className="text-white"
                    icon="pi pi-pencil"
                    onClick={() => {
                        setUpdateCompanyData(rowData);
                        if (!jSessionId || !wMonId) {
                            login();
                        } else {
                            // JSessionId ve wMonId zaten var, direkt update ekranını aç
                            setIsLoginLuca(true);
                            setUpdateTabVisible(true);
                        }
                    }}
                />
            </div>
        );
    };

    const footerTemplate = (
        <div>
            <Button label="Hayır" icon="pi pi-times" onClick={() => setVisible(false)} className="p-button-danger text-white" />
            <Button label="Evet" icon="pi pi-check" onClick={() => setVisible(false)} className="p-button-success text-white" />
        </div>
    );

    const footerTemplateForUpdateCredentials = (
        <div>
            <Button label="İptal" icon="pi pi-times" onClick={() => setUpdateCredentialsVisible(false)} className="p-button-danger text-white" />
            <Button label="Güncelle" icon="pi pi-check" onClick={() => handleUpdateCredentials()} className="p-button-success text-white" disabled={!lucaUsername || !lucaPassword || !lucaCustomerNumber} />
        </div>
    );

    const footerTemplateForRetry = (
        <div>
            <Button label="İptal" icon="pi pi-times" onClick={() => setRetrySessionVisible(false)} className="p-button-danger text-white" />
            <Button label="Tekrar Dene" icon="pi pi-check" onClick={() => handleRetrySession()} className="p-button-success text-white" disabled={!retrySelectedMonth || !retryEnteredBy} loading={loadingForRetry} />
        </div>
    );

    const footerTemplateForConfirmation = (
        <div>
            <Button label="İptal" icon="pi pi-times" onClick={() => setConfirmationVisible(false)} className="p-button-danger text-white" />
            <Button label="Gönder" icon="pi pi-send" onClick={() => handleConfirmSend()} className="p-button-success text-white" loading={loadingForSend} />
        </div>
    );

    const footerTemplateForCertificate = (
        <div>
            <Button label="İptal" icon="pi pi-times" onClick={() => setCertificateConfirmVisible(false)} className="p-button-danger text-white" />
            <Button label="Okudum, Onaylıyorum" icon="pi pi-check" onClick={() => handleSendCertificate()} className="p-button-success text-white" loading={loadingCertificate} />
        </div>
    );

    const handleCaptcha = (data) => {
        return `data:image/png;base64,${data?.captchaImage}`;
    };

    const handleReturnList = () => {
        setIsLoginLuca(false);
        setUpdateTabVisible(false);
        setUpdateCompanyData(null);
        getCompanyListFunc();
        getEledgerLogFunc();
    };

    const handleUpdateCredentials = async () => {
        setLoading(true);
        try {
            const res = await loginLuca(lucaUsername, lucaPassword, lucaCustomerNumber);

            setJSessionId(res.data.data.jSessionId);
            setWMonId(res.data.data.wMonId);

            if (res.data.data.jSessionId && res.data.data.wMonId) {
                await updateLucaCredentials({ username: lucaUsername, password: lucaPassword, customer_number: lucaCustomerNumber }, batchParamsRef.current);
                setUpdateCredentialsVisible(false);
                const companyAndPeriodList = await getCompanyAndPeriodList(res.data.data.jSessionId, res.data.data.wMonId);
                setResponse(companyAndPeriodList.data.data);
                setCompanyList(deleteCompanyIsHere(getCompanyForDropdown(companyAndPeriodList.data.data), lucaCompanies));
                setTimeout(() => {
                    getCompanyListFunc();
                    toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Luca giriş bilgileri başarıyla güncellendi', life: 3000 });
                }, 1);
            }
        } catch (error) {
            setTimeout(() => {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: error?.response?.data?.message, life: 3000 });
            }, 1);
        } finally {
            setLoading(false);
            setUpdateCredentialsVisible(false);
        }
    };

    const handleCaptchaSubmit = async () => {
        setLoading(true);
        setCaptchaLoading(true);
        try {
            const res = await sendCaptcha({ cookie: cookies, captcha: captcha });
            setJSessionId(res.data.data.jSessionId);
            setWMonId(res.data.data.wMonId);
            const companyAndPeriodList = await getCompanyAndPeriodList(res.data.data.jSessionId, res.data.data.wMonId);
            setResponse(companyAndPeriodList.data.data);
            setCompanyList(deleteCompanyIsHere(getCompanyForDropdown(companyAndPeriodList.data.data), lucaCompanies));
            setIsLoginLuca(true);
            setUpdateTabVisible(true);
            setTimeout(() => {
                toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Captcha başarıyla doğrulandı', life: 3000 });
            }, 1);
        } catch (error) {
            setCaptchaVisible(false);
            setTimeout(() => {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: error?.response?.data?.message, life: 3000 });
            }, 1);
        }
        setCaptchaLoading(false);
        setLoading(false);
        setCaptcha(null);
        setCaptchaImage(null);
        setCaptchaVisible(false);
        setCookies(null);
    };

    const login = async () => {
        setLoading(true);

        if (!lucaUsername || !lucaPassword || !lucaCustomerNumber) {
            setTimeout(() => {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Lütfen tüm alanları doldurunuz', life: 3000 });
            }, 1);
            setLoading(false);
            setUpdateCredentialsVisible(true);
            return;
        }

        try {
            const res = await loginLuca(lucaUsername, lucaPassword, lucaCustomerNumber);

            const companyAndPeriodList = await getCompanyAndPeriodList(res.data.data.jSessionId, res.data.data.wMonId);
            setJSessionId(res.data.data.jSessionId);
            setWMonId(res.data.data.wMonId);
            setResponse(companyAndPeriodList.data.data);
            setCompanyList(deleteCompanyIsHere(getCompanyForDropdown(companyAndPeriodList.data.data), lucaCompanies));
            setIsLoginLuca(true);
            setUpdateTabVisible(true);
            setTimeout(() => {
                toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Luca oturumu başarıyla açıldı', life: 3000 });
            }, 1);
        } catch (error) {
            setTimeout(() => {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: error?.response?.data?.message, life: 3000 });
            }, 1);
        }
        setLoading(false);
    };

    const handleMonthChange = (e) => {
        setSelectedMonth(e.value);

        if (e.value) {
            const year = e.value.getFullYear();
            const month = (e.value.getMonth() + 1).toString().padStart(2, '0'); // 0-indexli olduğu için +1, 01 formatında

            setSelectedYear(String(year));
            setSelectedMonthNumber(String(month));
        } else {
            setSelectedYear(null);
            setSelectedMonthNumber(null);
        }
    };

    const handleRetryMonthChange = (e) => {
        setRetrySelectedMonth(e.value);

        if (e.value) {
            const year = e.value.getFullYear();
            const month = (e.value.getMonth() + 1).toString().padStart(2, '0'); // 0-indexli olduğu için +1, 01 formatında

            setRetryYear(String(year));
            setRetryMonth(String(month));
        } else {
            setRetryYear(null);
            setRetryMonth(null);
        }
    };

    const handleSend = async () => {
        // Batch işlemi devam ediyorsa gönderimi engelle
        if (currentBatchId !== null) {
            setTimeout(() => {
                toast.current.show({ severity: 'warn', summary: 'Uyarı', detail: 'Toplu işlem devam ediyor, lütfen bekleyiniz', life: 3000 });
            }, 1);
            return;
        }

        // Gerekli alanları kontrol et
        if (!selectedReceipt?.length || !selectedMonth || !selectedYear || !enteredBy) {
            setTimeout(() => {
                toast.current.show({ severity: 'warn', summary: 'Uyarı', detail: 'Lütfen tüm alanları doldurunuz', life: 3000 });
            }, 1);
            return;
        }

        // Onay dialogunu göster
        setConfirmationVisible(true);
    };

    const handleConfirmSend = async () => {
        setConfirmationVisible(false);
        setLoadingForSend(true);
        const taxNumbers = selectedReceipt.map((item) => item.tax_number);

        try {
            const response = await batchLucaReceipt({ tax_number: taxNumbers, period: selectedYear, month: selectedMonthNumber, entered_by: enteredBy }, batchParamsRef.current);

            // Batch işlemi başarılı olursa polling'i başlat
            if (response.data.isSuccess && response.data.data && response.data.data.length > 0) {
                const batchId = response.data.data[0].batch_id;
                if (batchId) {
                    startBatchPolling(batchId);
                }
            }

            // Tüm alanları temizle
            setSelectedReceipt([]);
            setSelectedMonth(null);
            setSelectedYear(null);
            setSelectedMonthNumber(null);
            setEnteredBy(null);

            setTimeout(() => {
                toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Başarıyla işlem başlatıldı', life: 3000 });
                getCompanyListFunc();
                getBatchListFunc();
            }, 1);
        } catch (error) {
            setTimeout(() => {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: error?.response?.data?.message, life: 3000 });
            }, 1);
        } finally {
            setLoadingForSend(false);
        }
    };

    const handleRetrySession = async () => {
        if (!retrySessionData || !retrySelectedMonth || !retryEnteredBy) {
            setTimeout(() => {
                toast.current.show({ severity: 'warn', summary: 'Uyarı', detail: 'Lütfen tüm alanları doldurunuz', life: 3000 });
            }, 1);
            return;
        }

        setLoadingForRetry(true);

        try {
            const payload = {
                batch_id: retrySessionData.batch_id,
                session_id: retrySessionData.id,
                year: retryYear,
                month: retryMonth,
                entered_by: retryEnteredBy
            };

            await updateSession(payload, batchParamsRef.current);

            setRetrySessionVisible(false);
            setRetrySessionData(null);
            setRetryYear(null);
            setRetryMonth(null);
            setRetrySelectedMonth(null);
            setRetryEnteredBy(null);

            setTimeout(() => {
                toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'İşlem düzenlendi. Tüm işlemleri yeniden başlatmak için "Başarısızları Tekrar Dene" butonuna tıklayınız.', life: 5000 });
            }, 1);

            // Batch status'u yenile
            if (currentBatchId) {
                checkBatchStatus(currentBatchId);
            }
        } catch (error) {
            setTimeout(() => {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: error?.response?.data?.message, life: 3000 });
            }, 1);
        } finally {
            setLoadingForRetry(false);
        }
    };

    const handleSendCertificate = async () => {
        if (!selectedLedgerForCertificate) {
            setTimeout(() => {
                toast.current.show({ severity: 'warn', summary: 'Uyarı', detail: 'Defter bilgisi bulunamadı', life: 3000 });
            }, 1);
            return;
        }

        setLoadingCertificate(true);

        try {
            await sendCertificate({ ledger_uuid: selectedLedgerForCertificate.ledger_uuid }, batchParamsRef.current);

            setCertificateConfirmVisible(false);
            setSelectedLedgerForCertificate(null);

            setTimeout(() => {
                toast.current.show({
                    severity: 'success',
                    summary: 'Başarılı',
                    detail: 'İşlem başarıyla gönderildi. e-Defterler kontrol edilmeye başlandı.',
                    life: 5000
                });
            }, 1);

            // E-defter loglarını yenile
            getEledgerLogFunc();

            // 30 dakikalık polling'i başlat
            startCertificatePolling();
        } catch (error) {
            setTimeout(() => {
                toast.current.show({
                    severity: 'error',
                    summary: 'Hata',
                    detail: error?.response?.data?.message || 'e-Defter gönderimi sırasında hata oluştu',
                    life: 3000
                });
            }, 1);
        } finally {
            setLoadingCertificate(false);
        }
    };

    const startCertificatePolling = () => {
        // Önce mevcut polling'i temizle
        if (certificatePollingIntervalRef.current) {
            clearInterval(certificatePollingIntervalRef.current);
            certificatePollingIntervalRef.current = null;
        }

        // 30 dakika (1800000 ms) boyunca kontrol et
        const intervalId = setInterval(() => {
            getEledgerLogFunc();
        }, 1800000); // 30 dakika

        certificatePollingIntervalRef.current = intervalId;

        // İlk kontrolü hemen yap
        getEledgerLogFunc();
    };

    const stopCertificatePolling = () => {
        if (certificatePollingIntervalRef.current) {
            clearInterval(certificatePollingIntervalRef.current);
            certificatePollingIntervalRef.current = null;
        }
    };

    const onRowExpand = (event) => {
        // Optional: Show toast when row expands
        // toast.current.show({ severity: 'info', summary: 'Detaylar Açıldı', detail: event.data.luca_company_name, life: 3000 });
    };

    const onRowCollapse = (event) => {
        // Optional: Show toast when row collapses
        // toast.current.show({ severity: 'success', summary: 'Detaylar Kapatıldı', detail: event.data.luca_company_name, life: 3000 });
    };

    const allowExpansion = (rowData) => {
        let logItems = eledgerLog.filter((item) => item.tax_number === rowData.tax_number);
        let batchItems = batchStatusData.filter((session) => session.company.tax_number === rowData.tax_number);

        // Seçilen döneme göre filtrele
        if (selectedYear && selectedMonthNumber) {
            logItems = logItems.filter((item) => item.period === selectedYear && item.month === selectedMonthNumber);
            batchItems = batchItems.filter((session) => session.period.year === selectedYear && session.period.month === selectedMonthNumber);
        } else if (logItems.length > 0) {
            // Dönem seçilmemişse, en güncel dönemin kayıtlarına bak
            const sortedItems = [...logItems].sort((a, b) => {
                const dateA = parseInt(a.period) * 100 + parseInt(a.month);
                const dateB = parseInt(b.period) * 100 + parseInt(b.month);
                return dateB - dateA;
            });
            const latestPeriod = sortedItems[0].period;
            const latestMonth = sortedItems[0].month;

            logItems = logItems.filter((item) => item.period === latestPeriod && item.month === latestMonth);
            batchItems = batchItems.filter((session) => session.period.year === latestPeriod && session.period.month === latestMonth);
        }

        // Log kayıtları veya batch kayıtları varsa genişletmeye izin ver
        return logItems.length > 0 || batchItems.length > 0;
    };

    const rowExpansionTemplate = (data) => {
        let logItems = eledgerLog.filter((item) => item.tax_number === data.tax_number);
        let batchItems = batchStatusData.filter((session) => session.company.tax_number === data.tax_number);

        // Seçilen döneme göre filtrele
        if (selectedYear && selectedMonthNumber) {
            logItems = logItems.filter((item) => item.period === selectedYear && item.month === selectedMonthNumber);
            batchItems = batchItems.filter((session) => session.period.year === selectedYear && session.period.month === selectedMonthNumber);
        } else if (logItems.length > 0) {
            // Dönem seçilmemişse, en güncel dönemin defterlerini göster
            // En güncel dönemi bul (yıl ve ay'a göre sırala)
            const sortedItems = [...logItems].sort((a, b) => {
                const dateA = parseInt(a.period) * 100 + parseInt(a.month);
                const dateB = parseInt(b.period) * 100 + parseInt(b.month);
                return dateB - dateA; // En yeniden en eskiye
            });
            const latestPeriod = sortedItems[0].period;
            const latestMonth = sortedItems[0].month;

            // Sadece en güncel dönemin kayıtlarını göster
            logItems = logItems.filter((item) => item.period === latestPeriod && item.month === latestMonth);
            batchItems = batchItems.filter((session) => session.period.year === latestPeriod && session.period.month === latestMonth);
        }

        // Global getStatusUIInfo fonksiyonunu kullan
        const getStatusInfo = (statusCode, statusString = null) => {
            return getStatusUIInfo(statusCode, statusString);
        };

        const getBatchStatusInfo = (status) => {
            switch (status) {
                case 'pending':
                    return { text: 'Beklemede', severity: 'info', icon: 'pi pi-clock' };
                case 'processing':
                    return { text: 'İşleniyor', severity: 'warning', icon: 'pi pi-spin pi-spinner' };
                case 'success':
                    return { text: 'Tamamlandı', severity: 'success', icon: 'pi pi-check' };
                case 'error':
                    return { text: 'Başarısız', severity: 'danger', icon: 'pi pi-times' };
                case 'login':
                    return { text: 'Giriş Yapılıyor', severity: 'info', icon: 'pi pi-sign-in' };
                default:
                    return { text: status, severity: 'secondary', icon: 'pi pi-info-circle' };
            }
        };

        // DataTable için veri hazırlama
        const tableData = [];

        // E-defter log verilerini tabloya ekle
        logItems.forEach((logItem, logIndex) => {
            const period = `${logItem.month?.padStart(2, '0')}/${logItem.period}`;

            if (logItem?.ledgers && Array.isArray(logItem.ledgers) && logItem.ledgers.length > 0) {
                logItem.ledgers.forEach((ledger, ledgerIndex) => {
                    const statusInfo = getStatusInfo(ledger.statusCode, ledger.status);
                    const ledgerType = ledger.type === 'Journal' ? 'Yevmiye' : 'Kebir';

                    tableData.push({
                        id: `eledger-${logIndex}-${ledgerIndex}`,
                        type: 'E-Defter',
                        ledgerType: ledgerType,
                        status: statusInfo.text,
                        statusCode: ledger.statusCode,
                        rawStatus: ledger.status,
                        severity: statusInfo.severity,
                        icon: statusInfo.icon,
                        period: period,
                        documentId: ledger.documentId || '-',
                        message: '-',
                        progress: '-',
                        identifier: ledger.identifier || null,
                        tax_number: logItem.tax_number || null
                    });
                });
            } else {
                // Ledgers boşsa genel durum bilgisini göster
                const statusInfo = getStatusInfo(logItem.status_code, logItem.status);

                tableData.push({
                    id: `eledger-general-${logIndex}`,
                    type: 'E-Defter',
                    ledgerType: '-',
                    status: statusInfo.text,
                    statusCode: logItem.status_code,
                    rawStatus: logItem.status,
                    severity: statusInfo.severity,
                    icon: statusInfo.icon,
                    period: period,
                    documentId: logItem.identifier || '-',
                    message: logItem.message || '-',
                    progress: '-',
                    identifier: logItem.identifier || null,
                    tax_number: logItem.tax_number || null
                });
            }
        });

        // Batch status verilerini tabloya ekle
        batchItems.forEach((batchItem, batchIndex) => {
            const period = `${batchItem.period.month?.padStart(2, '0')}/${batchItem.period.year}`;
            const statusInfo = getBatchStatusInfo(batchItem.status);
            const progress = batchItem.progress || 0;

            tableData.push({
                id: `batch-${batchIndex}`,
                type: 'Batch İşlemi',
                ledgerType: '-',
                status: statusInfo.text,
                severity: statusInfo.severity,
                icon: statusInfo.icon,
                period: period,
                documentId: '-',
                message: batchItem.message || '-',
                progress: `%${progress}`,
                stats: batchItem.stats
            });
        });

        // DataTable column templates
        const statusBodyTemplate = (rowData) => {
            return <Button type="button" label={rowData.status} icon={rowData.icon} className={`p-button-${rowData.severity} p-button-sm text-white`} style={{ pointerEvents: 'none' }} />;
        };

        const typeBodyTemplate = (rowData) => {
            return <span className={`px-4 py-1 text-xs font-medium text-white border-round-2xl shadow-1 ${rowData.type === 'E-Defter' ? 'bg-blue-700' : 'bg-purple-600'}`}>{rowData.type === 'Batch İşlemi' ? 'Toplu İşlem' : rowData.type}</span>;
        };

        const ledgerTypeBodyTemplate = (rowData) => {
            if (rowData.ledgerType === '-') return rowData.ledgerType;
            let ledgerTypeColor = 'bg-green-600';
            if (rowData.ledgerType === 'Yevmiye') {
                ledgerTypeColor = 'bg-orange-500';
            } else {
                ledgerTypeColor = 'bg-teal-600';
            }
            return <span className={`px-4 py-1 text-xs font-medium text-white ${ledgerTypeColor} border-round-2xl shadow-1`}>{rowData.ledgerType}</span>;
        };

        const periodBodyTemplate = (rowData) => {
            return <span className="px-2 py-1 text-xs font-medium text-white bg-gray-600 border-round-2xl shadow-1">{rowData.period}</span>;
        };

        const progressBodyTemplate = (rowData) => {
            if (rowData.progress === '-') return rowData.progress;
            return <span className="px-2 py-1 text-xs font-medium text-white bg-orange-500 border-round-2xl shadow-1">{rowData.progress}</span>;
        };

        const statsBodyTemplate = (rowData) => {
            if (!rowData.stats) return '-';
            return (
                <div className="text-sm">
                    <div>Toplam: {rowData.stats.total_days}</div>
                    <div>Tamamlanan: {rowData.stats.completed_days}</div>
                    <div>Başarısız: {rowData.stats.failed_days}</div>
                    <div>İşleniyor: {rowData.stats.processing_days}</div>
                </div>
            );
        };

        if (tableData.length === 0) {
            return (
                <div className="p-3">
                    <h5>Durum Bilgisi - {data.luca_company_name}</h5>
                    <p className="text-500">Bu şirket için henüz durum bilgisi bulunmamaktadır.</p>
                </div>
            );
        }

        const showCreditBody = (data) => {
            return (
                <div className="flex flex-column gap-2">
                    <span className="px-2 py-1 text-xs font-medium text-white bg-pink-600 border-round-2xl shadow-1 w-fit">Toplam Borç: {showCredit(data, 'debit')}</span>
                    <span className="px-2 py-1 text-xs font-medium text-white bg-green-600 border-round-2xl shadow-1 w-fit">Toplam Alacak: {showCredit(data, 'credit')}</span>
                </div>
            );
        };

        // Defter PDF indirme fonksiyonu (certificate: false)
        const handleDownloadLedger = async (rowData) => {
            if (!rowData.identifier || !rowData.tax_number) {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'İndirme bilgileri eksik', life: 3000 });
                return;
            }

            setDownloadingLedgerId(rowData.id);

            try {
                const response = await ledgerView(
                    {
                        tax_number: rowData.tax_number,
                        identity: rowData.identifier,
                        certificate: false
                    },
                    batchParamsRef.current
                );

                if (response.data?.isSuccess && response.data?.data?.data) {
                    // Base64 datayı decode et ve indir
                    const base64Data = response.data.data.data;
                    const documentId = response.data.data.document_id || 'e-defter';

                    // Base64'ü blob'a çevir
                    const byteCharacters = atob(base64Data);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/pdf' });

                    // İndirme linkini oluştur
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = `${documentId}.pdf`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);

                    toast.current.show({ severity: 'success', summary: 'Başarılı', detail: `${documentId}.pdf indirildi`, life: 3000 });
                } else {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: response.data?.message || 'İndirme başarısız', life: 3000 });
                }
            } catch (error) {
                console.error('Ledger indirme hatası:', error);
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'İndirme sırasında bir hata oluştu', life: 3000 });
            } finally {
                setDownloadingLedgerId(null);
            }
        };

        // Report XML indirme fonksiyonu
        const handleDownloadReport = async (rowData) => {
            if (!rowData.identifier || !rowData.tax_number) {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'İndirme bilgileri eksik', life: 3000 });
                return;
            }

            setDownloadingReportId(rowData.id);

            try {
                const response = await reportData(
                    {
                        tax_number: rowData.tax_number,
                        identity: rowData.identifier,
                        certificate: true
                    },
                    batchParamsRef.current
                );

                if (response.data?.isSuccess && response.data?.data?.data) {
                    const xmlData = response.data.data.data;
                    const fileName = response.data.data.file_name || `${response.data.data.document_id || 'rapor'}.xml`;

                    // XML verisini blob'a çevir
                    const blob = new Blob([xmlData], { type: 'application/xml' });

                    // İndirme linkini oluştur
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);

                    toast.current.show({ severity: 'success', summary: 'Başarılı', detail: `${fileName} indirildi`, life: 3000 });
                } else {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: response.data?.message || 'İndirme başarısız', life: 3000 });
                }
            } catch (error) {
                console.error('Report indirme hatası:', error);
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'İndirme sırasında bir hata oluştu', life: 3000 });
            } finally {
                setDownloadingReportId(null);
            }
        };

        // Defter PDF görüntüleme fonksiyonu (certificate: false)
        const handleViewPdf = async (rowData) => {
            if (!rowData.identifier || !rowData.tax_number) {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Görüntüleme bilgileri eksik', life: 3000 });
                return;
            }

            setPdfViewerLoading(true);

            try {
                const response = await ledgerView(
                    {
                        tax_number: rowData.tax_number,
                        identity: rowData.identifier,
                        certificate: false
                    },
                    batchParamsRef.current
                );

                if (response.data?.isSuccess && response.data?.data?.data) {
                    const base64Data = response.data.data.data;
                    // rowData'dan gelen documentId'yi kullan (YEV... formatında)
                    const documentId = rowData.documentId || response.data.data.document_id || 'e-defter';

                    // Base64'ü binary'e çevir
                    const byteCharacters = atob(base64Data);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);

                    // Blob oluştur ve dosya adı ekle
                    const blob = new Blob([byteArray], { type: 'application/pdf' });
                    const file = new File([blob], `${documentId}.pdf`, { type: 'application/pdf' });

                    // Blob URL oluştur
                    const blobUrl = URL.createObjectURL(file);

                    setPdfViewerData({
                        url: blobUrl,
                        documentId: documentId
                    });
                    setPdfViewerVisible(true);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: response.data?.message || 'Görüntüleme başarısız', life: 3000 });
                }
            } catch (error) {
                console.error('PDF görüntüleme hatası:', error);
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Görüntüleme sırasında bir hata oluştu', life: 3000 });
            } finally {
                setPdfViewerLoading(false);
            }
        };

        // Berat PDF indirme fonksiyonu (certificate: true)
        const handleDownloadCertificate = async (rowData) => {
            if (!rowData.identifier || !rowData.tax_number) {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'İndirme bilgileri eksik', life: 3000 });
                return;
            }

            setDownloadingCertificateId(rowData.id);

            try {
                const response = await ledgerView(
                    {
                        tax_number: rowData.tax_number,
                        identity: rowData.identifier,
                        certificate: true
                    },
                    batchParamsRef.current
                );

                if (response.data?.isSuccess && response.data?.data?.data) {
                    // Base64 datayı decode et ve indir
                    const base64Data = response.data.data.data;
                    const documentId = response.data.data.document_id || 'berat';

                    // Base64'ü blob'a çevir
                    const byteCharacters = atob(base64Data);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/pdf' });

                    // İndirme linkini oluştur
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = `${documentId}-berat.pdf`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);

                    toast.current.show({ severity: 'success', summary: 'Başarılı', detail: `${documentId}-berat.pdf indirildi`, life: 3000 });
                } else {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: response.data?.message || 'İndirme başarısız', life: 3000 });
                }
            } catch (error) {
                console.error('Berat indirme hatası:', error);
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'İndirme sırasında bir hata oluştu', life: 3000 });
            } finally {
                setDownloadingCertificateId(null);
            }
        };

        // Berat PDF görüntüleme fonksiyonu (certificate: true)
        const handleViewCertificatePdf = async (rowData) => {
            if (!rowData.identifier || !rowData.tax_number) {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Görüntüleme bilgileri eksik', life: 3000 });
                return;
            }

            setCertificatePdfViewerLoading(true);

            try {
                const response = await ledgerView(
                    {
                        tax_number: rowData.tax_number,
                        identity: rowData.identifier,
                        certificate: true
                    },
                    batchParamsRef.current
                );

                if (response.data?.isSuccess && response.data?.data?.data) {
                    const base64Data = response.data.data.data;
                    const documentId = rowData.documentId || response.data.data.document_id || 'berat';

                    // Base64'ü binary'e çevir
                    const byteCharacters = atob(base64Data);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);

                    // Blob oluştur ve dosya adı ekle
                    const blob = new Blob([byteArray], { type: 'application/pdf' });
                    const file = new File([blob], `${documentId}-berat.pdf`, { type: 'application/pdf' });

                    // Blob URL oluştur
                    const blobUrl = URL.createObjectURL(file);

                    setPdfViewerData({
                        url: blobUrl,
                        documentId: `${documentId} - Berat`
                    });
                    setPdfViewerVisible(true);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: response.data?.message || 'Görüntüleme başarısız', life: 3000 });
                }
            } catch (error) {
                console.error('Berat PDF görüntüleme hatası:', error);
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Görüntüleme sırasında bir hata oluştu', life: 3000 });
            } finally {
                setCertificatePdfViewerLoading(false);
            }
        };

        // İşlemler kolonu body template
        const actionsBodyTemplate = (rowData) => {
            if (!rowData.identifier) return '-';

            return (
                <div className="flex gap-1">
                    {/* Defter PDF Butonları */}
                    <Button icon="pi pi-eye" className="p-button-help p-button-sm text-white" tooltip="Defter PDF Görüntüle" tooltipOptions={{ position: 'top' }} loading={pdfViewerLoading} onClick={() => handleViewPdf(rowData)} />
                    <Button
                        icon="pi pi-download"
                        className="p-button-success p-button-sm text-white"
                        tooltip="Defter PDF İndir"
                        tooltipOptions={{ position: 'top' }}
                        loading={downloadingLedgerId === rowData.id}
                        onClick={() => handleDownloadLedger(rowData)}
                    />
                    {/* Berat PDF Butonları */}
                    <Button
                        icon="pi pi-eye"
                        className="p-button-primary p-button-sm text-white"
                        tooltip="Berat PDF Görüntüle"
                        tooltipOptions={{ position: 'top' }}
                        loading={certificatePdfViewerLoading}
                        onClick={() => handleViewCertificatePdf(rowData)}
                    />
                    <Button
                        icon="pi pi-download"
                        className="p-button-warning p-button-sm text-white"
                        tooltip="Berat PDF İndir"
                        tooltipOptions={{ position: 'top' }}
                        loading={downloadingCertificateId === rowData.id}
                        onClick={() => handleDownloadCertificate(rowData)}
                    />
                    {/* XML İndir */}
                    <Button icon="pi pi-file" className="p-button-info p-button-sm text-white" tooltip="XML İndir" tooltipOptions={{ position: 'top' }} loading={downloadingReportId === rowData.id} onClick={() => handleDownloadReport(rowData)} />
                </div>
            );
        };

        // Gönderilmeyenleri filtrele (statusCode 50, 100 veya completed olanlar GÖNDERİLMİŞ sayılır)
        const isNotSentStatus = (statusCode, rawStatus) => {
            const sentCodes = ['50', '100', 50, 100];
            const sentStatuses = ['completed', 'success'];
            return !sentCodes.includes(statusCode) && !sentStatuses.includes(rawStatus?.toLowerCase());
        };

        // Filtrelenmiş tablo verisi
        const getFilteredTableData = () => {
            if (!expansionNotSentFilter[data.tax_number]) {
                return tableData;
            }
            return tableData.filter((row) => {
                // Batch işlemleri için status kontrolü
                if (row.type === 'Batch İşlemi') {
                    return row.status !== 'Tamamlandı' && row.severity !== 'success';
                }
                // E-Defter için statusCode kontrolü - gönderilmemiş olanları göster
                // Gönderilmiş: statusCode 50 (GİB'e gönderildi) veya 100 (Tamamlandı)
                return isNotSentStatus(row.statusCode, row.rawStatus);
            });
        };

        const filteredTableData = getFilteredTableData();

        // Alt tablo header'ı
        const expansionHeader = (
            <div className="flex align-items-center gap-6">
                <span className="font-semibold">Durum Kayıtları</span>
                <div className="flex gap-2">
                    {expansionNotSentFilter[data.tax_number] ? (
                        <Button label="Filtreyi Temizle" icon="pi pi-times" className="p-button-secondary p-button-sm" onClick={() => setExpansionNotSentFilter((prev) => ({ ...prev, [data.tax_number]: false }))} />
                    ) : (
                        <Button label="Gönderilmeyenleri Göster" icon="pi pi-ban" className="p-button-danger p-button-sm text-white" onClick={() => setExpansionNotSentFilter((prev) => ({ ...prev, [data.tax_number]: true }))} />
                    )}
                </div>
            </div>
        );

        return (
            <div className="p-3">
                <h5>Durum Detayları - {data.luca_company_name}</h5>
                <DataTable
                    value={filteredTableData}
                    header={expansionHeader}
                    className="p-datatable-sm"
                    emptyMessage="Durum bilgisi bulunamadı"
                    paginator
                    rows={5}
                    rowsPerPageOptions={[5, 10, 25, 100, 200]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="{totalRecords} durum kaydı"
                >
                    <Column field="type" header="Tür" body={typeBodyTemplate} style={{ minWidth: '8rem' }} />
                    <Column field="ledgerType" header="Defter Türü" body={ledgerTypeBodyTemplate} style={{ minWidth: '8rem' }} />
                    <Column field="status" header="Durum" body={statusBodyTemplate} style={{ minWidth: '12rem' }} />
                    <Column field="period" header="Dönem" body={periodBodyTemplate} style={{ minWidth: '6rem' }} />
                    <Column header="Bilgiler" body={showCreditBody(data)} style={{ minWidth: '6rem' }} />
                    <Column field="documentId" header="Belge ID" style={{ minWidth: '8rem' }} />
                    <Column header="İşlemler" body={actionsBodyTemplate} style={{ minWidth: '6rem' }} />
                </DataTable>
            </div>
        );
    };

    const toastHandler = (severity, summary, detail, life) => {
        setTimeout(() => {
            toast.current.show({ severity: severity, summary: summary, detail: detail, life: life });
        }, 1);
    };

    const ledgerStatusSummary = (rowData, field) => {
        let logItems = eledgerLog.filter((item) => item.tax_number === rowData.tax_number);
        let batchItems = batchStatusData.filter((session) => session.company.tax_number === rowData.tax_number);

        // Seçilen döneme göre filtrele
        if (selectedYear && selectedMonthNumber) {
            logItems = logItems.filter((item) => item.period === selectedYear && item.month === selectedMonthNumber);
            batchItems = batchItems.filter((session) => session.period.year === selectedYear && session.period.month === selectedMonthNumber);
        } else if (logItems.length > 0) {
            // Dönem seçilmemişse, en güncel dönemin defterlerini göster
            const sortedItems = [...logItems].sort((a, b) => {
                const dateA = parseInt(a.period) * 100 + parseInt(a.month);
                const dateB = parseInt(b.period) * 100 + parseInt(b.month);
                return dateB - dateA;
            });
            const latestPeriod = sortedItems[0].period;
            const latestMonth = sortedItems[0].month;

            logItems = logItems.filter((item) => item.period === latestPeriod && item.month === latestMonth);
            batchItems = batchItems.filter((session) => session.period.year === latestPeriod && session.period.month === latestMonth);
        }

        // Batch işlemi devam ediyorsa öncelikle batch durumunu göster
        if (batchItems.length > 0) {
            const activeBatch = batchItems[0]; // En son batch işlemi

            const getBatchStatusInfo = (status) => {
                switch (status) {
                    case 'pending':
                        return { text: 'Beklemede', severity: 'info', icon: 'pi pi-clock' };
                    case 'processing':
                        return { text: 'İşleniyor', severity: 'warning', icon: 'pi pi-spin pi-spinner' };
                    case 'success':
                        return { text: 'Tamamlandı', severity: 'success', icon: 'pi pi-check' };
                    case 'error':
                        return { text: 'Başarısız', severity: 'danger', icon: 'pi pi-times' };
                    case 'login':
                        return { text: 'Giriş Yapılıyor', severity: 'info', icon: 'pi pi-sign-in' };
                    default:
                        return { text: status, severity: 'secondary', icon: 'pi pi-info-circle' };
                }
            };

            const statusInfo = getBatchStatusInfo(activeBatch.status);
            const progress = activeBatch.progress || 0;
            const period = `${activeBatch.period.month?.padStart(2, '0')}/${activeBatch.period.year}`;

            // Eğer field 'period' ise sadece finansal/istatistik bilgilerini göster
            if (field === 'period') {
                // Batch durumunda log bilgisini çek
                const batchLog = logItems.length > 0 ? logItems[logItems.length - 1] : null;

                return (
                    <div className="flex flex-column w-fit gap-2">
                        <span className="px-2 py-1 text-xs font-medium text-white bg-gray-600 border-round-2xl shadow-1">Dönem: {period}</span>
                        {batchLog ? (
                            <>
                                <span className="px-2 py-1 text-xs font-medium text-white bg-pink-600 border-round-2xl shadow-1">
                                    Toplam Borç: {batchLog?.total_debit ? new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(batchLog.total_debit) : '₺0,00'}
                                </span>
                                <span className="px-2 py-1 text-xs font-medium text-white bg-green-600 border-round-2xl shadow-1">
                                    Toplam Alacak: {batchLog?.total_credit ? new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(batchLog.total_credit) : '₺0,00'}
                                </span>
                                <span className="px-2 py-1 text-xs font-medium text-white bg-blue-600 border-round-2xl shadow-1">Toplam Fiş Sayısı: {batchLog?.row_count ? batchLog?.row_count : '0'}</span>
                            </>
                        ) : null}
                    </div>
                );
            }

            // Eğer field 'status' ise batch durum detaylarını göster
            const statusElements = [];
            batchItems.forEach((batchItem, batchIndex) => {
                const period = `${batchItem.period.month?.padStart(2, '0')}/${batchItem.period.year}`;
                const statusInfo = getBatchStatusInfo(batchItem.status);
                const progress = batchItem.progress || 0;

                statusElements.push(
                    <div key={`batch-${batchIndex}`} className="flex flex-column gap-2 mb-3 p-2 border-round">
                        <div className="flex align-items-center gap-2">
                            <Button type="button" label={`${statusInfo.text} - ${batchItem.message}`} icon={statusInfo.icon} className={`p-button-${statusInfo.severity} p-button-sm text-white cursor-auto`} />
                            <span className="px-2 py-1 text-xs font-medium text-white bg-gray-600 border-round-2xl shadow-1">{period}</span>
                            <span className="px-2 py-1 text-xs font-medium text-white bg-orange-500 border-round-2xl shadow-1">{`%${progress}`}</span>
                        </div>
                        <div className="text-sm text-600">
                            <div>Toplam: {batchItem.stats.total_days} gün</div>
                            <div>
                                Tamamlanan: {batchItem.stats.completed_days} | Başarısız: {batchItem.stats.failed_days} | İşleniyor: {batchItem.stats.processing_days}
                            </div>
                        </div>
                    </div>
                );
            });

            return (
                <div className="flex flex-column gap-2">
                    <div className="w-full">{statusElements}</div>
                </div>
            );
        }

        // Batch işlemi yoksa e-defter log durumunu göster
        if (logItems.length === 0 && field === 'status') {
            return <span className="text-500">Durum bilgisi yok</span>;
        } else if (logItems.length === 0 && field === 'period') {
            return <span className="text-500">Bilgi yok</span>;
        }

        // En son log kaydının genel durumunu göster
        const latestLogItem = logItems[logItems.length - 1];

        // Eğer ledgers varsa detaylı bilgi göster
        if (latestLogItem.ledgers && latestLogItem.ledgers.length > 0) {
            const totalItems = logItems.reduce((acc, item) => acc + (item.ledgers ? item.ledgers.length : 0), 0);

            // Ledgers içindeki en son durumu al
            const allLedgers = latestLogItem.ledgers;
            const latestLedger = allLedgers[allLedgers.length - 1];

            // Global getStatusUIInfo fonksiyonunu kullan
            const statusInfo = getStatusUIInfo(latestLedger.statusCode, latestLedger.status);
            const period = `${latestLogItem.month?.padStart(2, '0')}/${latestLogItem.period}`;
            const message = latestLedger.message || latestLogItem.message || '';

            return (
                <>
                    {field === 'status' ? (
                        <div className="flex align-items-center gap-2">
                            <Button type="button" label={message ? `${statusInfo.text} - ${message}` : statusInfo.text} icon={statusInfo.icon} className={`p-button-${statusInfo.severity} p-button-sm text-white`} style={{ pointerEvents: 'none' }} />
                            <span className="px-2 py-1 text-xs font-medium text-white bg-gray-600 border-round-2xl shadow-1">{period}</span>
                            <span className="text-600">{totalItems} kayıt</span>
                        </div>
                    ) : field === 'period' ? (
                        <div className="flex flex-column align-items-center gap-2">
                            <span className="px-2 py-1 text-xs font-medium text-white bg-gray-600 border-round-2xl shadow-1">Dönem: {period}</span>
                            <span className="px-2 py-1 text-xs font-medium text-white bg-pink-600 border-round-2xl shadow-1">
                                Toplam Borç: {latestLogItem?.total_debit ? new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(latestLogItem.total_debit) : '₺0,00'}
                            </span>
                            <span className="px-2 py-1 text-xs font-medium text-white bg-green-600 border-round-2xl shadow-1">
                                Toplam Alacak: {latestLogItem?.total_credit ? new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(latestLogItem.total_credit) : '₺0,00'}
                            </span>
                            <span className="px-2 py-1 text-xs font-medium text-white bg-blue-600 border-round-2xl shadow-1">Toplam Fiş Sayısı: {latestLogItem?.row_count ? latestLogItem?.row_count : '0'}</span>
                        </div>
                    ) : null}
                </>
            );
        }

        // Ledgers boşsa genel durum bilgisini göster - global getStatusUIInfo kullan
        const statusInfo = getStatusUIInfo(latestLogItem.status_code, latestLogItem.status);
        const period = `${latestLogItem.month?.padStart(2, '0')}/${latestLogItem.period}`;
        const message = latestLogItem.message || '';

        return (
            <div className="flex align-items-center gap-2">
                <Button type="button" label={message ? `${statusInfo.text} - ${message}` : statusInfo.text} icon={statusInfo.icon} className={`p-button-${statusInfo.severity} p-button-sm text-white`} style={{ pointerEvents: 'none' }} />
                <span className="px-2 py-1 text-xs font-medium text-white bg-gray-600 border-round-2xl shadow-1">{period}</span>
            </div>
        );
    };
    const rowIsTrue = (rowData) => {
        let check = rowData.luca_company_id === null;
        if (check) {
            return (
                <Button
                    severity="danger"
                    icon="pi pi-exclamation-triangle"
                    tooltip={'Luca bağlantısı yok. Düzenlemek için tıklayınız.'}
                    tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }}
                    onClick={() => {
                        setUpdateCompanyData(rowData);
                        login();
                    }}
                />
            );
        }

        return <Button severity="success" icon="pi pi-check" tooltip="Luca bağlantısı var" className="text-white" tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }} />;
    };

    if (noCompany) {
        return <NotFound page="batchLucaPage" />;
    }

    const showCredit = (company, type) => {
        if (type === 'credit') {
            return eledgerLog.find((log) => log?.tax_number === company?.tax_number)?.total_credit
                ? new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(eledgerLog.find((log) => log?.tax_number === company?.tax_number)?.total_credit)
                : 'Borç Bilgisi Bulunamadı';
        } else if (type === 'debit') {
            return eledgerLog.find((log) => log?.tax_number === company?.tax_number)?.total_debit
                ? new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(eledgerLog.find((log) => log?.tax_number === company?.tax_number)?.total_debit)
                : 'Alacak Bilgisi Bulunamadı';
        }
    };

    const showVoucherCount = (company) => {
        return eledgerLog.find((log) => log?.tax_number === company?.tax_number)?.row_count ? eledgerLog.find((log) => log?.tax_number === company?.tax_number)?.row_count : 'Fiş Sayısı Bulunamadı';
    };

    return (
        <>
            <Toast ref={toast} />
            {loading ? (
                <div className="flex justify-content-center align-items-center h-screen">
                    <Loading loading={loading} onChangeLoading={() => setLoading(false)} />
                </div>
            ) : (
                <div className="layout-wrapper">
                    <div className="layout-main-content h-screen p-4 ">
                        <div className="w-full card h-full border-round-xl flex flex-column">
                            <div className="flex justify-content-start relative mb-4">
                                <img src="/assets/layout/images/i-uyum-logo-light.png" alt="i-uyum-logo" className="w-8rem" />
                            </div>
                            {!updateTabVisible && !isLoginLuca ? (
                                <div className="flex flex-column gap-4">
                                    {/* Calendar and Entry Name Fields Section */}

                                    <div className="flex flex-wrap gap-4 align-items-end">
                                        <div className="flex flex-column gap-2">
                                            <label className="text-md font-semibold">E-Defter Dönemi</label>
                                            <Calendar className="w-20jrem" value={selectedMonth} view="month" dateFormat="mm/yy" locale="tr" onChange={handleMonthChange} showIcon placeholder="Dönem seçiniz" showButtonBar />
                                        </div>
                                        <div className="flex flex-column gap-2">
                                            <label className="text-md font-semibold">Gönderen Kişi</label>
                                            <InputText className="w-20rem" placeholder="Gönderen Kişi" value={enteredBy} onChange={(e) => setEnteredBy(e.target.value)} />
                                        </div>
                                    </div>

                                    <DataTable
                                        ref={dt}
                                        value={getFilteredCompanyList()}
                                        dataKey="id"
                                        paginator
                                        rows={10}
                                        rowsPerPageOptions={[5, 10, 25, 100, 200]}
                                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                        currentPageReportTemplate="{totalRecords} şirketten {first} ila {last} arası gösteriliyor"
                                        globalFilter={globalFilter}
                                        header={header}
                                        emptyMessage="Luca Şirket Bulunamadı"
                                        className="p-datatable-gridlines"
                                        selectionMode={'checkbox'}
                                        selection={selectedReceipt}
                                        onSelectionChange={(e) => setSelectedReceipt(e.value)}
                                        scrollable
                                        scrollHeight={getScrollHeight()}
                                        expandedRows={expandedRows}
                                        onRowToggle={(e) => setExpandedRows(e.data)}
                                        onRowExpand={onRowExpand}
                                        onRowCollapse={onRowCollapse}
                                        rowExpansionTemplate={rowExpansionTemplate}
                                    >
                                        <Column expander={allowExpansion} style={{ width: '3rem' }} />
                                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                                        <Column field="" header="" style={{ width: '2rem' }} body={(rowData) => rowIsTrue(rowData)}></Column>
                                        <Column field="tax_number" header="Vergi No" sortable style={{ minWidth: '6rem' }}></Column>
                                        <Column field="full_name" header="Ünvan" sortable style={{ minWidth: '6rem' }}></Column>
                                        <Column field="luca_company_name" header="Luca Şirket Adı" sortable style={{ minWidth: '6rem' }}></Column>
                                        <Column field="customer_number" header="Müşteri Numarası" sortable style={{ minWidth: '6rem' }}></Column>
                                        <Column field="status" body={(rowData) => ledgerStatusSummary(rowData, 'status')} header="Durum" sortable style={{ minWidth: '6rem' }}></Column>
                                        <Column header="Bilgiler" body={(rowData) => ledgerStatusSummary(rowData, 'period')} style={{ minWidth: '12rem' }} />
                                        <Column header="İşlemler" body={actionBodyTemplate} className="text-center" exportable={false} style={{ minWidth: '5rem' }}></Column>
                                    </DataTable>
                                </div>
                            ) : (
                                <div header="Şirket Bilgileri">
                                    <LucaUpdate
                                        isLoginLuca={isLoginLuca}
                                        response={response}
                                        companyList={companyList}
                                        username={lucaUsername}
                                        password={lucaPassword}
                                        customerNumber={lucaCustomerNumber}
                                        id={updateCompanyData?.id}
                                        handleReturnList={handleReturnList}
                                        batchId={batchParamsRef.current}
                                        toastHandler={toastHandler}
                                        setIsLoginLuca={setIsLoginLuca}
                                        updateCompanyData={updateCompanyData}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <Dialog visible={visible} onHide={() => setVisible(false)} header="Dosya Silme" modal style={{ width: '350px' }} footer={footerTemplate}>
                        <div className="flex align-items-center gap-2">
                            <p className="m-0">Deneme dialog</p>
                        </div>
                    </Dialog>
                    <Dialog visible={updateCredentialsVisible} onHide={() => setUpdateCredentialsVisible(false)} header="Luca giriş bilgilerini güncelle" modal style={{ width: '450px' }} footer={footerTemplateForUpdateCredentials}>
                        <div className="flex flex-column gap-4">
                            <div className="flex flex-column gap-2">
                                <label htmlFor="username">Kullanıcı Adı</label>
                                <InputText id="username" value={lucaUsername} onChange={(e) => setLucaUsername(e.target.value)} />
                            </div>
                            <div className="flex flex-column gap-2">
                                <label htmlFor="password">Şifre</label>
                                <InputText id="password" value={lucaPassword} onChange={(e) => setLucaPassword(e.target.value)} />
                            </div>
                            <div className="flex flex-column gap-2">
                                <label htmlFor="customerNumber">Müşteri Numarası</label>
                                <InputText id="customerNumber" value={lucaCustomerNumber} onChange={(e) => setLucaCustomerNumber(e.target.value)} />
                            </div>
                        </div>
                    </Dialog>
                    <Dialog visible={retrySessionVisible} onHide={() => setRetrySessionVisible(false)} header="İşlemi Tekrar Dene" modal style={{ width: '450px' }} footer={footerTemplateForRetry}>
                        <div className="flex flex-column gap-4">
                            <div className="flex flex-column gap-2">
                                <label className="mb-2 block">E-Defter Dönemi</label>
                                <Calendar className="w-full" showButtonBar value={retrySelectedMonth} view="month" dateFormat="mm/yy" locale="tr" onChange={handleRetryMonthChange} showIcon placeholder="Lütfen bir ay seçiniz" />
                            </div>
                            <div className="flex flex-column gap-2">
                                <label htmlFor="retryEnteredBy">Gönderen Kişi</label>
                                <InputText id="retryEnteredBy" placeholder="Gönderen Kişi" value={retryEnteredBy} onChange={(e) => setRetryEnteredBy(e.target.value)} />
                            </div>
                        </div>
                    </Dialog>
                    <Dialog
                        visible={captchaVisible}
                        onHide={() => setCaptchaVisible(false)}
                        header="Doğrulama Kodu"
                        modal
                        style={{ width: '450px' }}
                        footer={
                            <>
                                <Button severity="danger" onClick={() => setCaptchaVisible(false)}>
                                    Kapat
                                </Button>
                                <Button severity="success" disabled={!captcha} className="text-white" loading={captchaLoading} onClick={() => handleCaptchaSubmit()} label="Doğrula" />
                            </>
                        }
                    >
                        <div className="flex align-items-center gap-2">
                            <p className="m-0 w-full gap-4 flex flex-column">
                                {captchaImage && <img src={captchaImage} alt="captcha" className="w-full" />}
                                Lütfen doğrulama kodunu giriniz.
                                <InputText
                                    placeholder="Doğrulama Kodu"
                                    onChange={(e) => setCaptcha(e.target.value)}
                                    className="w-full"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && captcha) {
                                            handleCaptchaSubmit();
                                        }
                                    }}
                                />
                            </p>
                        </div>
                    </Dialog>
                    <Dialog visible={confirmationVisible} onHide={() => setConfirmationVisible(false)} header="İşlemi Onayla" modal style={{ width: '450px' }} footer={footerTemplateForConfirmation}>
                        <div className="flex flex-column gap-4">
                            <div className="p-3 border-round bg-yellow-50 border-yellow-200">
                                <h5 className="mt-0 mb-3 text-yellow-800">E-Defter Gönderim Onayı</h5>
                                <div className="flex flex-column gap-2 text-yellow-700">
                                    <div className="flex align-items-center gap-2">
                                        <i className="pi pi-calendar"></i>
                                        <strong>Dönem:</strong>
                                        <span>{selectedMonth ? `${(selectedMonth.getMonth() + 1).toString().padStart(2, '0')}/${selectedMonth.getFullYear()}` : '-'}</span>
                                    </div>
                                    <div className="flex align-items-center gap-2">
                                        <i className="pi pi-user"></i>
                                        <strong>Gönderen Kişi:</strong>
                                        <span>{enteredBy || '-'}</span>
                                    </div>
                                    <div className="flex align-items-center gap-2">
                                        <i className="pi pi-building"></i>
                                        <strong>Şirket Sayısı:</strong>
                                        <span>{selectedReceipt?.length || 0} şirket</span>
                                    </div>
                                    {selectedReceipt && selectedReceipt.length > 0 && (
                                        <div className="flex flex-column gap-2 mt-3">
                                            <strong>Seçili Şirketler:</strong>
                                            <div className="max-h-8rem overflow-y-auto">
                                                {selectedReceipt.map((company, index) => (
                                                    <div key={index} className="flex align-items-center gap-2 p-2 border-round bg-white border-1 border-yellow-300 mb-1">
                                                        <span className="text-xs font-medium text-yellow-800 bg-yellow-100 px-2 py-1 border-round">{index + 1}</span>
                                                        <div className="flex flex-column gap-1">
                                                            <span className="font-semibold text-yellow-800">{company.luca_company_name || 'Şirket Adı Yok'}</span>
                                                            <span className="text-xs text-yellow-600">VKN: {company.tax_number}</span>
                                                            {/* <span className="text-xs text-yellow-600">Toplam Borç: {showCredit(company, 'debit')}</span>
                                                            <span className="text-xs text-yellow-600">Toplam Alacak: {showCredit(company, 'credit')}</span>
                                                            <span className="text-xs text-yellow-600">Toplam Fiş Sayısı: {showVoucherCount(company)}</span> */}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <p className="m-0 text-center">Bu bilgiler ile e-defter işlemini başlatmak istediğinizden emin misiniz?</p>
                        </div>
                    </Dialog>
                    <Dialog visible={certificateConfirmVisible} onHide={() => setCertificateConfirmVisible(false)} header="Okudum Onaylıyorum" modal style={{ width: '450px' }} footer={footerTemplateForCertificate}>
                        <div className="flex flex-column gap-4">
                            <div className="p-3 border-round bg-blue-50 border-blue-200">
                                <h5 className="mt-0 mb-3 text-blue-800">e-Defter Gönderim Onayı</h5>
                                <div className="flex flex-column gap-2 text-blue-700">
                                    <div className="flex align-items-center gap-2">
                                        <i className="pi pi-building"></i>
                                        <strong>Şirket:</strong>
                                        <span>{selectedLedgerForCertificate?.company_name || '-'}</span>
                                    </div>
                                    <div className="flex align-items-center gap-2">
                                        <i className="pi pi-id-card"></i>
                                        <strong>Vergi No:</strong>
                                        <span>{selectedLedgerForCertificate?.tax_number || '-'}</span>
                                    </div>
                                    <div className="flex align-items-center gap-2">
                                        <i className="pi pi-calendar"></i>
                                        <strong>Dönem:</strong>
                                        <span>{selectedLedgerForCertificate?.month && selectedLedgerForCertificate?.period ? `${selectedLedgerForCertificate.month.padStart(2, '0')}/${selectedLedgerForCertificate.period}` : '-'}</span>
                                    </div>
                                    <div className="flex align-items-center gap-2">
                                        <i className="pi pi-file"></i>
                                        <strong>Toplam Borç:</strong>
                                        <span>{showCredit(selectedLedgerForCertificate, 'debit') || '-'}</span>
                                    </div>
                                    <div className="flex align-items-center gap-2">
                                        <i className="pi pi-file"></i>
                                        <strong>Toplam Alacak:</strong>
                                        <span>{showCredit(selectedLedgerForCertificate, 'credit') || '-'}</span>
                                    </div>
                                    <div className="flex align-items-center gap-2">
                                        <i className="pi pi-file"></i>
                                        <strong>Toplam Fiş Sayısı:</strong>
                                        <span>{showVoucherCount(selectedLedgerForCertificate) || '-'}</span>
                                    </div>
                                </div>
                            </div>
                            <p className="m-0 text-center">Seçmiş olduğum firmalara ait oluşturulacak e-Defter bilgilerinin doğruluğunu kabul ediyor ve onaylıyorum.</p>
                        </div>
                    </Dialog>
                    <Dialog
                        visible={batchCertificateConfirmVisible}
                        onHide={() => setBatchCertificateConfirmVisible(false)}
                        header="Toplu e-Defter Gönderimi"
                        modal
                        style={{ width: '550px' }}
                        footer={
                            <div>
                                <Button label="İptal" icon="pi pi-times" onClick={() => setBatchCertificateConfirmVisible(false)} className="p-button-danger text-white" />
                                <Button label="Okudum, Onaylıyorum" icon="pi pi-check" onClick={() => handleConfirmBatchCertificateSend()} className="p-button-success text-white" loading={loadingCertificate} />
                            </div>
                        }
                    >
                        <div className="flex flex-column gap-4">
                            <div className="p-3 border-round bg-blue-50 border-blue-200">
                                <h5 className="mt-0 mb-3 text-blue-800">Toplu e-Defter Gönderim Onayı</h5>
                                <div className="flex flex-column gap-2 text-blue-700">
                                    <div className="flex align-items-center gap-2">
                                        <i className="pi pi-book"></i>
                                        <strong>Toplam Defter Sayısı:</strong>
                                        <span>{selectedLedgersForBatchCertificate.length} adet</span>
                                    </div>
                                    {selectedLedgersForBatchCertificate && selectedLedgersForBatchCertificate.length > 0 && (
                                        <div className="flex flex-column gap-2 mt-3">
                                            <strong>Gönderilecek Defterler:</strong>
                                            <div className="max-h-20rem overflow-y-auto">
                                                {selectedLedgersForBatchCertificate.map((ledger, index) => (
                                                    <div key={index} className="flex flex-column gap-1 p-2 border-round bg-white border-1 border-blue-300 mb-2">
                                                        <div className="flex align-items-center gap-2">
                                                            <span className="text-xs font-medium text-blue-800 bg-blue-100 px-2 py-1 border-round">{index + 1}</span>
                                                            <span className="font-semibold text-blue-800">{ledger.company_name || 'Bilinmeyen Şirket'}</span>
                                                        </div>
                                                        <div className="flex flex-column gap-1 ml-5">
                                                            <span className="text-xs text-blue-600">VKN: {ledger.tax_number}</span>
                                                            <span className="text-xs text-blue-600">
                                                                Dönem: {ledger.month?.padStart(2, '0')}/{ledger.period}
                                                            </span>
                                                            <span className="text-xs text-blue-600">Toplam Borç: {ledger.total_debit ? new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(ledger.total_debit) : '₺0,00'}</span>
                                                            <span className="text-xs text-blue-600">
                                                                Toplam Alacak: {ledger.total_credit ? new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(ledger.total_credit) : '₺0,00'}
                                                            </span>
                                                            <span className="text-xs text-blue-600">Fiş Sayısı: {ledger.row_count || 0}</span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <p className="m-0 text-center">Seçmiş olduğum firmalara ait oluşturulacak e-Defter bilgilerinin doğruluğunu kabul ediyor ve onaylıyorum.</p>
                        </div>
                    </Dialog>
                    <Dialog
                        visible={pdfViewerVisible}
                        onHide={() => {
                            // Blob URL'i temizle (memory leak önlemi)
                            if (pdfViewerData?.url) {
                                URL.revokeObjectURL(pdfViewerData.url);
                            }
                            setPdfViewerVisible(false);
                            setPdfViewerData(null);
                        }}
                        header={`PDF Görüntüleyici - ${pdfViewerData?.documentId || 'e-Defter'}`}
                        modal
                        maximizable
                        style={{ width: '90vw', height: '90vh' }}
                        contentStyle={{ height: 'calc(90vh - 6rem)' }}
                    >
                        {pdfViewerData?.url && (
                            <iframe
                                src={`${pdfViewerData.url}#navpanes=0&scrollbar=1&toolbar=1&statusbar=0&messages=0&filename=${pdfViewerData?.documentId || 'e-Defter'}.pdf`}
                                style={{ width: '100%', height: '100%', border: 'none' }}
                                title={pdfViewerData?.documentId || 'e-Defter'}
                            />
                        )}
                    </Dialog>
                </div>
            )}
        </>
    );
}
